import { useState } from 'react';

import { useSignupMethod } from '@hotjar/webapp/features/Registration/hooks/useRegisterQueryParams';
import { SelectSignUpMethodStep } from './steps/SelectSignUpMethodStep/SelectSignUpMethodStep';
import { VerificationStep } from './steps/VerificationStep/VerificationStep';
import { SplitRegisterLayout } from './components';
import { useUserCreationForm } from './hooks/useUserCreationForm';
import { useUserCreationFormTracking } from './hooks/useUserCreationFormTracking';

export const Registration = (): JSX.Element => {
  const signupMethod = useSignupMethod();
  const userCreationTracking = useUserCreationFormTracking(signupMethod);
  const { trackOnEmailFormSubmit, trackOnDefaultSSOSubmit } = userCreationTracking;

  const [isCaptchaVisible, setIsCaptchaVisible] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState<string | null>(null);

  const {
    vidValue,
    userDetails,
    resetUserDetailsForm,
    selectEmailMethod,
    shouldShowEmailForm,
    isEmailVerificationPending,
    onFormSubmit,
    isFormLoaded,
    isCampaignValid,
    isStepOneSubmitInProgress,
  } = useUserCreationForm(
    trackOnEmailFormSubmit,
    trackOnDefaultSSOSubmit,
    signupMethod,
    recaptchaValue,
    isCaptchaVisible,
  );

  return (
    <SplitRegisterLayout isLoading={!isFormLoaded}>
      {!shouldShowEmailForm && isEmailVerificationPending ? (
        <VerificationStep
          userDetailsWithVid={{
            ...userDetails,
            emailVerificationVid: vidValue,
            recaptcha: recaptchaValue,
          }}
          signupMethod={signupMethod}
          resetUserDetailsForm={resetUserDetailsForm}
          userCreationTracking={userCreationTracking}
        />
      ) : (
        <SelectSignUpMethodStep
          recaptchaValue={recaptchaValue}
          isCaptchaVisible={isCaptchaVisible}
          setIsCaptchaVisible={setIsCaptchaVisible}
          setRecaptchaValue={setRecaptchaValue}
          defaultData={userDetails}
          shouldShowEmailForm={shouldShowEmailForm}
          submitUserFormData={onFormSubmit}
          selectEmailMethod={selectEmailMethod}
          isStepOneSubmitInProgress={isStepOneSubmitInProgress}
          isCampaignValid={isCampaignValid}
        />
      )}
    </SplitRegisterLayout>
  );
};
